import { cx } from "../../lib/cx";

export interface ChipOption<T extends string = string> {
  label: string;
  value: T;
}

interface ChipGroupProps<T extends string = string> {
  options: ChipOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel?: string;
}

/**
 * Chip-style single-select, used in place of a native <select> for filter
 * groups and form pickers (matches the v2 design's pill picker pattern).
 */
export function ChipGroup<T extends string = string>({ options, value, onChange, ariaLabel }: ChipGroupProps<T>) {
  return (
    <div className="chip-picker" role="group" aria-label={ariaLabel}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={cx("chip-option")}
          data-active={opt.value === value}
          aria-pressed={opt.value === value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
